import { TagItem } from './TagItem';

export function ListTag({ listTags = [] }) {
  return listTags?.map((tag) => <TagItem key={tag} tag={tag} />);
}
